module.exports = __webpack_public_path__ + "static/media/beach-3.176f00eb.jpg";